"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETRType = exports.WebsocketWrapper = exports.coverageThreshold = exports.jestSonarReporters = exports.getThirdPartyTokenMapper = exports.getThirdPartyProviderMapper = exports.Cache = exports.utils = exports.athena = exports.connect = exports.getFlowConfigMapper = exports.getSettingsMapper = exports.getPermissionsMapper = exports.getFormTemplateMapper = exports.getCTRMapper = exports.getQueueConfigMapper = exports.getCTRSummaryMapper = exports.getWallboardListMapper = exports.getWallboardMapper = exports.getUserMapper = exports.getTokenMapper = exports.getTimerMapper = exports.getReportMapper = exports.getQueueStatsMapper = exports.getQueueMapper = exports.getLinesMapper = exports.getInboundNumberMapper = exports.getCompanyMapper = exports.getAgentMapper = void 0;
const agent_1 = require("./agent");
Object.defineProperty(exports, "getAgentMapper", { enumerable: true, get: function () { return agent_1.getAgentMapper; } });
const websocket_1 = __importDefault(require("./clients/websocket/websocket"));
exports.WebsocketWrapper = websocket_1.default;
const company_1 = require("./company");
Object.defineProperty(exports, "getCompanyMapper", { enumerable: true, get: function () { return company_1.getCompanyMapper; } });
const ctr_1 = require("./ctr");
Object.defineProperty(exports, "getCTRMapper", { enumerable: true, get: function () { return ctr_1.getCTRMapper; } });
const ctr_summary_1 = require("./ctr-summary");
Object.defineProperty(exports, "getCTRSummaryMapper", { enumerable: true, get: function () { return ctr_summary_1.getCTRSummaryMapper; } });
const flow_config_1 = require("./flow-config");
Object.defineProperty(exports, "getFlowConfigMapper", { enumerable: true, get: function () { return flow_config_1.getFlowConfigMapper; } });
const form_templates_1 = require("./form-templates");
Object.defineProperty(exports, "getFormTemplateMapper", { enumerable: true, get: function () { return form_templates_1.getFormTemplateMapper; } });
const inbound_number_1 = require("./inbound-number");
Object.defineProperty(exports, "getInboundNumberMapper", { enumerable: true, get: function () { return inbound_number_1.getInboundNumberMapper; } });
const lines_1 = require("./lines");
Object.defineProperty(exports, "getLinesMapper", { enumerable: true, get: function () { return lines_1.getLinesMapper; } });
const permissions_1 = require("./permissions");
Object.defineProperty(exports, "getPermissionsMapper", { enumerable: true, get: function () { return permissions_1.getPermissionsMapper; } });
const queue_1 = require("./queue");
Object.defineProperty(exports, "getQueueMapper", { enumerable: true, get: function () { return queue_1.getQueueMapper; } });
const queue_config_1 = require("./queue-config");
Object.defineProperty(exports, "getQueueConfigMapper", { enumerable: true, get: function () { return queue_config_1.getQueueConfigMapper; } });
const queue_stats_1 = require("./queue-stats");
Object.defineProperty(exports, "getQueueStatsMapper", { enumerable: true, get: function () { return queue_stats_1.getQueueStatsMapper; } });
const report_1 = require("./report");
Object.defineProperty(exports, "getReportMapper", { enumerable: true, get: function () { return report_1.getReportMapper; } });
const athena = __importStar(require("./services/athena"));
exports.athena = athena;
const connect = __importStar(require("./services/connect"));
exports.connect = connect;
const cache_1 = __importDefault(require("./services/cache"));
exports.Cache = cache_1.default;
const settings_1 = require("./settings");
Object.defineProperty(exports, "getSettingsMapper", { enumerable: true, get: function () { return settings_1.getSettingsMapper; } });
const timer_1 = require("./timer");
Object.defineProperty(exports, "getTimerMapper", { enumerable: true, get: function () { return timer_1.getTimerMapper; } });
const token_1 = require("./token");
Object.defineProperty(exports, "getTokenMapper", { enumerable: true, get: function () { return token_1.getTokenMapper; } });
const third_party_provider_1 = require("./third-party-provider");
Object.defineProperty(exports, "getThirdPartyProviderMapper", { enumerable: true, get: function () { return third_party_provider_1.getThirdPartyProviderMapper; } });
const third_party_token_1 = require("./third-party-token");
Object.defineProperty(exports, "getThirdPartyTokenMapper", { enumerable: true, get: function () { return third_party_token_1.getThirdPartyTokenMapper; } });
const user_1 = require("./user");
Object.defineProperty(exports, "getUserMapper", { enumerable: true, get: function () { return user_1.getUserMapper; } });
const utils = __importStar(require("./utils"));
exports.utils = utils;
const wallboard_1 = require("./wallboard");
Object.defineProperty(exports, "getWallboardMapper", { enumerable: true, get: function () { return wallboard_1.getWallboardMapper; } });
const wallboardlist_1 = require("./wallboardlist");
Object.defineProperty(exports, "getWallboardListMapper", { enumerable: true, get: function () { return wallboardlist_1.getWallboardListMapper; } });
const etr_1 = require("./etr");
Object.defineProperty(exports, "ETRType", { enumerable: true, get: function () { return etr_1.ETRType; } });
const { jestSonarReporters } = require('./jest-extensions/jest-sonar-reporter');
exports.jestSonarReporters = jestSonarReporters;
const { coverageThreshold } = require('./jest-extensions/jest-coverage-threshold');
exports.coverageThreshold = coverageThreshold;
